// 緯度経度→XYZタイル範囲取得関数
export const getTileRange = (z, minLng, minLat, maxLng, maxLat) => {
  const lngLatToTile = (lng, lat, zoom) => {
    const x = Math.floor(((lng + 180) / 360) * Math.pow(2, zoom));
    const y = Math.floor(
      ((1 -
        Math.log(
          Math.tan((lat * Math.PI) / 180) +
          1 / Math.cos((lat * Math.PI) / 180)
        ) /
        Math.PI) /
        2) *
      Math.pow(2, zoom)
    );
    return { x, y };
  };

  const min = lngLatToTile(minLng, maxLat, z); // 北西
  const max = lngLatToTile(maxLng, minLat, z); // 南東

  return {
    minX: min.x,
    minY: min.y,
    maxX: max.x,
    maxY: max.y,
  };
}

// ６時間モードデータ計算
export const getNestDataH6H15 = (data, h6Switch) => {
  return (h6Switch)
    ? data.map(arr => arr.length > 9 ? arr.slice(0, -9) : [])
    : data
}

export const getDataH6H15 = (data, h6Switch) => {
  return (h6Switch)
    ? data.length > 9 ? data.slice(0, -9) : data
    : data
}


export const getFilteredDataByArea = (areas, apiData, keyName) => {
  // 欲しいキーのリストを用意
  let targetKeys = []
  for (const area of areas) {
    targetKeys.push(`${keyName}${area}`)
  }

  // 対象キーのみ抜き出して新しいオブジェクトを作成
  const filteredData = Object.fromEntries(
    Object.entries(apiData).filter(([key]) => targetKeys.includes(key))
  );

  return filteredData
};

const getMultiPolygonCenter = (coordinates) => {
  const allCoords = [];

  coordinates.map(polygon => {
    polygon.map(ring => {
      ring.map(point => {
        allCoords.push(point); // [lon, lat]
      });
    });
  });

  const lons = allCoords.map(coord => coord[0]);
  const lats = allCoords.map(coord => coord[1]);

  const avgLon = lons.reduce((sum, val) => sum + val, 0) / lons.length;
  const avgLat = lats.reduce((sum, val) => sum + val, 0) / lats.length;

  return [avgLon, avgLat]; // [経度, 緯度]
}

export const getPolygonOrMultiPolygonCenter = (coordinates) => {
  const allCoords = [];

  // MultiPolygon: [[[[]]]], Polygon: [[[]]]
  if (Array.isArray(coordinates[0][0][0])) {
    // MultiPolygon
    coordinates.forEach(polygon => {
      polygon.forEach(ring => {
        ring.forEach(point => {
          allCoords.push(point); // [lon, lat]
        });
      });
    });
  } else {
    // Polygon
    coordinates.forEach(ring => {
      ring.forEach(point => {
        allCoords.push(point); // [lon, lat]
      });
    });
  }

  const lons = allCoords.map(coord => coord[0]);
  const lats = allCoords.map(coord => coord[1]);

  const avgLon = lons.reduce((sum, val) => sum + val, 0) / lons.length;
  const avgLat = lats.reduce((sum, val) => sum + val, 0) / lats.length;

  return [avgLon, avgLat];
};

// 時刻の配列を取得
export const getTimeAry = (date_ary, isH6) => {
  let result = []
  for (const date of date_ary) {
    result.push(date.slice(-5));
  }
  if (isH6 && result && result.length > 9) {
    result = result.slice(0, -9)
  }
  return result
}

// 選択地域の最大値を取得（何の最大値かは「keyName」で指定できる）
export const getMax = (area_code_ary, apiData, keyName, isH6) => {
  // APIから取得したデータの内、指定したエリアコードのもののみ抽出
  const filteredData = getFilteredDataByArea(area_code_ary, apiData, keyName)
  // 抽出したデータの value 配列を取得（各配列）
  const values = Object.values(filteredData);

  // 予報値として、value 配列の6番目以降（index 6～）を切り出す
  let sliced = values.map(arr => arr.slice(6))
  // 6時間モードの場合6番目から12番目までを切り出す
  if (isH6) {
    sliced = values.map(arr => arr.slice(6, -9))
  }

  // すべての sliced 配列を 1つのフラットな配列にして最大値を取得する
  const result = Math.max(...sliced.flat());
  return result
};

export const getAllByCodeAndKey = (code_ary, apiData, keyName, isH6) => {
  // let all_data = apiData
  const all_data = apiData.map(item => {
    const newItem = { code: item.code };

    for (const [key, value] of Object.entries(item)) {
      if (Array.isArray(value) && key === keyName) {
          newItem[key] = value
        // 6時間モードの場合０番目から12番目までの値
        if (isH6) {
          newItem[key] = value.slice(0, -9); // 配列なら末尾9つカット
        }
      }
    }
    return newItem;
  });
  // 必要なコードのもののみ抽出
  const result = all_data.filter(item =>
    code_ary.includes(item.code)
  );
  return result
};

// 選択地域の最大値を取得（何の最大値かは「keyName」で指定できる）
export const getMaxByDateTimeApiData = (code_ary, apiData, keyName, isH6) => {
  // APIから取得したデータの内、指定したエリアコードのもののみ抽出
  const filteredData = getAllByCodeAndKey(code_ary, apiData, keyName, isH6)
  // 抽出したデータの value 配列の同じインデックス同士を比較して、最大値を作る配列を返す
  const values = filteredData.map(item => item[keyName]);

  let result = values
  if (values.length > 0) {
    result = values.reduce((acc, curr) => {
      return acc.map((val, i) => Math.max(val, curr[i]));
    });
  }
  return result
};

// 選択地域の最大値を取得（何の最大値かは「keyName」で指定できる）
export const getMaxByDateTime = (data, keyName) => {
  const values = data.map(item => item[keyName])
    .filter(arr => Array.isArray(arr) && arr.length > 0);

  let result = values
  if (values.length > 0) {
    result = values.reduce((acc, curr) => {
      return acc.map((val, i) => Math.max(val, curr[i]));
    });
  }

  return result
};

/**
 * ランキングを取得
 * @param {Array} area_code_ary - 選択地域
 * @param {Object} apiData - APIから取得したデータ
 * @param {Object} features - 地域情報取得用のデータ
 * @param {String} keyName - 参照したいデータのキー（h1_val_：雨量、risk_val_：リスク）
 * @param {number} liimit - 上位何件まで取得するか
 * @param {boolean} isH6 - 6時間モードかどうか
 * @returns {Array} ランキングデータ
 */
export const getRank = (area_code_ary, features, apiData, keyName, liimit, isH6) => {

  // APIから取得したデータの内、指定したエリアコードのもののみ抽出
  const filteredData = getFilteredDataByArea(area_code_ary, apiData, keyName)
  const all_ary = Object.entries(filteredData)
    .map(([key, value]) => {
      const area_code = Number(key.replace(keyName, '')); // keyから字コードを取得
      // 対象字コードの feature を抽出
      const filteredFeatures = features.find(f =>
        f.properties.id === area_code
      );
      // featureから字名を取得
      const area_name = filteredFeatures.properties.name
      // featureから緯度経度を取得
      const lat_lng = getMultiPolygonCenter(filteredFeatures.geometry.coordinates)
      const area_lng = lat_lng[0]
      const area_lat = lat_lng[1]

      // 予報値として、value 配列の6番目以降（index 6～）を切り出す
      let sliced = value.slice(6)
      // 6時間モードの場合6番目から12番目までの値の最大値（slice の end は 13 にする）
      if (isH6) {
        sliced = value.slice(6, -9);
      }
      // 予報値の最大値を取得
      const max = Math.max(...sliced);
      return { area_code, area_name, area_lat, area_lng, max };
    })
    .sort((a, b) => b.max - a.max); // 最大値の降順にソート

  // 指定された上限数までを取得
  let result = []
  if (all_ary.length > liimit) {
    result = all_ary.slice(0, liimit)
  } else {
    result = all_ary
  }
  return result
};

export const getRankWithLimit = (data, limit) => {
  const max_ary = data.map(item => ({
    area_code: item.area_code,
    area_name: item.area_name,
    area_lat: item.area_lat,
    area_lng: item.area_lng,
    max: (Math.max(...item.risk_val.slice(6)) === -Infinity ? 0 : Math.max(...item.risk_val.slice(6)))
  }));
  const result = max_ary
    .sort((a, b) => b.max - a.max)
    .slice(0, limit);

  return result
};

export const getH1RankWithLimit = (data, liimit) => {
  const max_ary = data.map(item => ({
    area_code: item.area_code,
    area_name: item.area_name,
    area_lat: item.area_lat,
    area_lng: item.area_lng,
    max: (Math.max(...item.h1_val.slice(6)) === -Infinity ? 0 : Math.max(...item.h1_val.slice(6)))
  }));
  const result = max_ary
    .sort((a, b) => b.max - a.max)
    .slice(0, liimit);

  return result
};

export const getSrRankWithLimit = (data, limit, flg) => {
  const max_ary = data.map(item => {
    const sr_lvs = flg ? item.sr_lv.slice(6) : item.sr_lv;
    const sr_values = flg ? item.sr_val.slice(6) : item.sr_val;
    return {
      city_code: item.city_code,
      city_name: item.city_name,
      area_lat: item.area_lat,
      area_lng: item.area_lng,
      sr_lv_max: Math.max(...sr_lvs),
      sr_val_max: Math.max(...sr_values),
    };
  });

  const result = max_ary
    .sort((a, b) => {
      if (b.sr_lv_max !== a.sr_lv_max) {
        return b.sr_lv_max - a.sr_lv_max; // 第1優先: sr_lv_max 降順
      }
      if (b.sr_val_max !== a.sr_val_max) {
        return b.sr_val_max - a.sr_val_max; // 第2優先: sr_val_max 降順
      }
      return b.city_code - a.city_code; // 第3優先: city_code 降順（数値として比較）
    })
    .slice(0, limit);

  return result;
};

export const getRoadRankWithLimit = (data, limit, selectedRoadName = null) => {
  const max_ary = data.map(item => ({
    msh_code: item.msh_code,
    city_name: item.city_name,
    txt_road_name: item.txt_road_name,
    area_lat: item.area_lat,
    area_lng: item.area_lng,
    lv_max: Math.max(...item.lv.slice(6)),
    h1_val_max: Math.max(...item.h1_val.slice(6)),
    of_val_max: Math.max(...item.of_val.slice(6)),
    rsk_val_max: Math.max(...item.rsk_val.slice(6))
  }));

  const grouped = {};

  for (const item of max_ary) {
    const key = item.txt_road_name;
    if (!grouped[key]) {
      grouped[key] = { ...item };
    } else {
      grouped[key] = {
        ...grouped[key],
        lv_max: Math.max(grouped[key].lv_max, item.lv_max),
        h1_val_max: Math.max(grouped[key].h1_val_max, item.h1_val_max),
        of_val_max: Math.max(grouped[key].of_val_max, item.of_val_max),
        rsk_val_max: Math.max(grouped[key].rsk_val_max, item.rsk_val_max)
      };
    }
  }

  // フィルタリング処理
  let filtered = Object.values(grouped);
  if (selectedRoadName && selectedRoadName.length > 0) {
    filtered = filtered.filter(item => {
      const roadNames = item.txt_road_name
        .split(',')
        .map(n => n.trim());

      return selectedRoadName.some(selected =>
        roadNames.includes(selected)
      );
    });
  }

  return filtered
    .sort((a, b) => b.lv_max - a.lv_max)
    .slice(0, limit);
};

/**
 * 全日時断面のリスクと地域情報を取得
 * @param {Array} area_code_ary - 選択地域
 * @param {Object} features - 地域情報取得用のデータ
 * @param {Object} apiData - APIから取得したデータ
 * @param {String} keyName - 参照したいデータのキー（h1_val_：雨量、risk_val_：リスク）
 * @param {boolean} isH6 - 6時間モードかどうか
 * @returns {Array} 全日時断面のリスクと地域情報
 */
export const getAllByDateTimeWithAreaInfo_bk = (area_code_ary, features, apiData, keyName, isH6) => {

  // APIから取得したデータの内、指定したエリアコードのもののみ抽出
  const filteredData = getFilteredDataByArea(area_code_ary, apiData, keyName)

  const result = Object.entries(filteredData)
    .map(([key, value]) => {
      const area_code = Number(key.replace(keyName, '')); // keyから字コードを取得
      // 対象字コードの feature を抽出
      const filteredFeatures = features.find(f =>
        f.properties.id === area_code
      );
      // featureから字名を取得
      const area_name = filteredFeatures.properties.name
      // featureから緯度経度を取得
      const lat_lng = getMultiPolygonCenter(filteredFeatures.geometry.coordinates)
      const area_lng = lat_lng[0]
      const area_lat = lat_lng[1]

      let risk_val = value
      // 6時間モードの場合０番目から12番目までの値
      if (isH6) {
        risk_val = value.slice(0, -9);
      }
      return { area_code, area_name, area_lat, area_lng, risk_val };
    })

  return result
};

/**
 * ランキングを取得
 * @param {Array} telDataLatest - 選択地域の水位計データ
 * @param {Object} apiData - APIから取得したデータ
 * @param {Object} features - 地域情報取得用のデータ
 * @param {String} risk - 参照したいデータのキー（risk_val：水位危険度、pct_val：水位パーセント、mtr_val：水位、border_purple：閾値（氾濫危険水位）、border_red：閾値（避難判断水位）、border_yellow：閾値（氾濫注意水位）、border_green：閾値（水防団待機水位）
 * @param {String} pct - 参照したいデータのキー（risk_val：水位危険度、pct_val：水位パーセント、mtr_val：水位、border_purple：閾値（氾濫危険水位）、border_red：閾値（避難判断水位）、border_yellow：閾値（氾濫注意水位）、border_green：閾値（水防団待機水位）
 * @param {String} mtr - 参照したいデータのキー（risk_val：水位危険度、pct_val：水位パーセント、mtr_val：水位、border_purple：閾値（氾濫危険水位）、border_red：閾値（避難判断水位）、border_yellow：閾値（氾濫注意水位）、border_green：閾値（水防団待機水位）
 * @param {String} borderPurple - 参照したいデータのキー（risk_val：水位危険度、pct_val：水位パーセント、mtr_val：水位、border_purple：閾値（氾濫危険水位）、border_red：閾値（避難判断水位）、border_yellow：閾値（氾濫注意水位）、border_green：閾値（水防団待機水位）
 * @param {String} borderRed - 参照したいデータのキー（risk_val：水位危険度、pct_val：水位パーセント、mtr_val：水位、border_purple：閾値（氾濫危険水位）、border_red：閾値（避難判断水位）、border_yellow：閾値（氾濫注意水位）、border_green：閾値（水防団待機水位）
 * @param {String} borderYellow - 参照したいデータのキー（risk_val：水位危険度、pct_val：水位パーセント、mtr_val：水位、border_purple：閾値（氾濫危険水位）、border_red：閾値（避難判断水位）、border_yellow：閾値（氾濫注意水位）、border_green：閾値（水防団待機水位）
 * @param {String} borderGreen - 参照したいデータのキー（risk_val：水位危険度、pct_val：水位パーセント、mtr_val：水位、border_purple：閾値（氾濫危険水位）、border_red：閾値（避難判断水位）、border_yellow：閾値（氾濫注意水位）、border_green：閾値（水防団待機水位）
 * @param {number} date_ary_length - 何件目が最新か
 * @param {number} limit - 上位何件まで取得するか
 * @param {boolean} isH6 - 6時間モードかどうか
 * @returns {Array} ランキングデータ
 */
export const getRankBsn = (tel_code_ary, features, apiData, sort_key_nsme_1, sort_key_nsme_2, date_ary_length, limit) => {
  if (features.length == 0) { return []; }
  const code_filter_ary = apiData.filter(item =>
      tel_code_ary.includes(item.code)
  );
  const all_data = code_filter_ary.map(item => {
    const newItem = { code: item.code };
    // 対象telコードの feature を抽出
    const filteredFeatures = features.find(f =>
        f.properties.tel_code === item.code
    );
    // featureからメッシュコードを取得
    const tel_code = filteredFeatures.properties.tel_code
    const msh_code = filteredFeatures.properties.msh_code
    // featureから水位計名、河川名を取得
    const name = filteredFeatures.properties.name
    const txt_river_name = filteredFeatures.properties.txt_river_name
    // featureから緯度経度を取得
    const lng = filteredFeatures.geometry.coordinates[0]
    const lat = filteredFeatures.geometry.coordinates[1]


    // 各キーの値を整理して newItem に追加
    for (const [key, value] of Object.entries(item)) {
      if (Array.isArray(value)) {
        // 配列でかつ is_current に該当するインデックスがある場合だけ値を取得
        if (
            value === null ||
            value.length < 1
        ) {
            newItem[key] = "-";
        } else {
            // is_current 配列から 1 のインデックスを取得
            const currentIndex = item.is_current.findIndex(flag => flag === 1);

            if (currentIndex === -1 || value[currentIndex] === null) {
              newItem[key] = "-";
            } else {
              const maxVal = Math.max(...value);
              newItem[key] = isFinite(maxVal) ? maxVal : "-";
            }
        }
      } else {
        newItem[key] = value;
      }
    }
    newItem['tel_code'] = tel_code
    newItem['msh_code'] = msh_code
    newItem['name'] = name
    newItem['txt_river_name'] = txt_river_name
    newItem['lng'] = lng
    newItem['lat'] = lat
    return newItem;
  });
  const sort_data = all_data.filter(item => item !== null)
    .sort((a, b) => {
      if (b[sort_key_nsme_1] !== a[sort_key_nsme_1]) {
          return a[sort_key_nsme_1] - b[sort_key_nsme_1]; // 優先1: 水位危険度（降順）
      }
      return a[sort_key_nsme_2] - b[sort_key_nsme_2];   // 優先2: 水位パーセント（降順）
    });

  // 指定された上限数までを取得
  let result = []
  if (sort_data.length > limit) {
      result = sort_data.slice(0, limit)
  } else {
      result = sort_data
  }
  return result
};

// 水位計の時刻の配列を取得（10分ごと）(7時間分)
export const getTelTimeAry = (date_ary) => {
  let result = []
  for (const date of date_ary) {
    result.push(date.slice(11, 16));
  }
  // 7時間分を取得
  if (result.length > 43) {
    result = result.slice(-44);
  }

  // 配列の中で最初に':00'となる時刻を取得
  const firstIndex = result.findIndex(time => time.endsWith("00"));

  // キリよく表示させるためfirstIndexから最後までを取得
  result = result.slice(firstIndex, result.length);

  return result
}

/**
 * 全日時断面のリスクと地域情報を取得
 * @param {Array} code_ary - 選択地域
 * @param {Object} apiData - APIから取得したデータ
 * @param {boolean} isH6 - 6時間モードかどうか
 * @returns {Array} 全日時断面のリスクと1時間雨量
 */
export const getAllByDateTime = (code_ary, apiData, isH6) => {

  const grouped = {};
  for (const key in apiData) {
    const [prefix, code] = key.split('_val_');
    if (!grouped[code]) {
      grouped[code] = { code: Number(code) };
    }
    let risk_val = apiData[key]
    // 6時間モードの場合０番目から12番目までの値
    if (isH6) {
      risk_val = apiData[key].slice(0, -9);
    }
    grouped[code][`${prefix}_val`] = risk_val;
  }
  // 全データを配列に変換
  const all_data = Object.values(grouped);
  // 必要なコードのもののみ抽出
  const result = all_data.filter(item =>
    code_ary.includes(item.code)
  );
  return result
};

export const getAllByCode = (code_ary, apiData, isH6) => {
  let all_data = apiData
  // 6時間モードの場合０番目から12番目までの値
  if (isH6) {
    all_data = apiData.map(item => {
      const newItem = { code: item.code };

      for (const [key, value] of Object.entries(item)) {
        if (Array.isArray(value)) {
          newItem[key] = value.slice(0, -9); // 配列なら末尾9つカット
        }
      }

      return newItem;
    });
  }
  // 必要なコードのもののみ抽出
  const result = all_data.filter(item =>
    code_ary.includes(item.code)
  );
  return result
};

export const getAllMtrDateTime = (telData, telDateAll) => {
  // is_current が 1 のインデックスを全部取得
  const indices = telData.is_current
    .map((flag, i) => (flag === 1 ? i : null))
    .filter(i => i !== null);

  if (indices.length === 0) return []; // 1 がなければ空配列

  const mtrVal = telData.mtr_val;

  // 0番目から最初の is_current=1 の位置まで
  const result = mtrVal.slice(0, indices[0] + 1);

  // 後ろから telDateAll 件だけ残す
  return result.slice(-telDateAll);
};

// /**
//  * 全日時断面のリスクと地域情報を取得
//  * @param {Array} code_ary - 選択地域
//  * @param {Object} apiData - APIから取得したデータ
//  * @param {boolean} isH6 - 6時間モードかどうか
//  * @returns {Array} 全日時断面のリスクと1時間雨量
//  */
// export const getAllBySrDateTime = (code_ary, apiData) => {

//   const grouped = {};
//   for (const key in apiData) {
//     // 'prefix_type_code' の形式（例: sr_lv_1234567, sr_val_1234567）
//     const match = key.match(/(.+?)_(lv|val)_(\d+)/);
//     if (!match) continue;

//     const prefix = match[1]; // 例: 'sr'
//     const type = match[2];   // 'lv' or 'val'
//     const code = match[3];   // 例: '1234567'

//     if (!grouped[code]) {
//       grouped[code] = { code: Number(code) };
//     }

//     let val = apiData[key];

//     grouped[code][`${prefix}_${type}`] = val;
//   }

//   const all_data = Object.values(grouped);
//   const result = all_data.filter(item =>
//     code_ary.includes(item.code)
//   );

//   return result;
// };

/**
 * 2つのオブジェクト配列を結合する
 * @param {Object} data1 - APIから取得したデータ
 * @param {Object} data2 - APIから取得したデータ
 * @returns {Array} 2つのオブジェクト配列を結合して返す
 */
export const joinData = (data1, data2) => {
  const data2Map = Object.fromEntries(data2.map(item => [item.code, item]));

  const all_data = data1.map(item => ({
    ...item,
    ...(data2Map[item.code] || {})
  }));

  return all_data;
};

// /**
//  * 全日時断面のリスクと地域情報を取得
//  * @param {Array} code_ary - 選択地域
//  * @param {Object} srApiData - APIから取得したデータ
//  * @param {Object} rainApiData - APIから取得したデータ
//  * @param {boolean} isH6 - 6時間モードかどうか
//  * @returns {Array} 全日時断面のリスクと1時間雨量
//  */
// export const getAllBySrRainDateTime = (code_ary, srApiData, rainApiData, isH6) => {
//   const grouped = {};

//   // 共通処理化する関数
//   const processApiData = (apiData) => {
//     for (const key in apiData) {
//       // 'prefix_type_code' の形式（例: sr_lv_1234567, sr_val_1234567）
//       const match = key.match(/(.+?)_(lv|val)_(\d+)/);
//       if (!match) continue;

//       const prefix = match[1]; // 例: 'sr'
//       const type = match[2];   // 'lv' or 'val'
//       const code = match[3];   // 例: '1234567'

//       if (!grouped[code]) {
//         grouped[code] = { code: Number(code) };
//       }

//       let val = apiData[key];

//       // isH6 モードのとき、lv/val 両方 slice する
//       if (isH6) {
//         val = Array.isArray(val) ? val.slice(0, -9) : val;
//       }

//       grouped[code][`${prefix}_${type}`] = val;
//     }
//   };

//   // 両方の API データを処理
//   processApiData(srApiData);
//   processApiData(rainApiData);

//   // フィルタして必要なコードだけ返す
//   const all_data = Object.values(grouped);
//   const result = all_data.filter(item =>
//     code_ary.includes(item.code)
//   );

//   return result;
// };

/**
 * 全日時断面のリスクと地域情報を取得
 * @param {Array} code_ary - 選択地域
 * @param {Object} apiData - APIから取得したデータ
 * @returns {Array} 全日時断面のリスクと1時間雨量
 */
export const getAllByScatterDateTime = (code_ary, apiData) => {

  const result = apiData.filter(item =>
    code_ary.includes(item.msh_code)
  );

  return result;
};

/**
 * 全日時断面のリスクと地域情報を取得
 * @param {Array} code_ary - 選択地域
 * @param {Object} apiData - APIから取得したデータ
 * @param {boolean} isH6 - 6時間モードかどうか
 * @returns {Array} 全日時断面のリスクと1時間雨量
 */
export const filterDataByCodeAry = (code_ary, apiData) => {

  const result = apiData.filter(item =>
    code_ary.includes(item.code)
  );

  return result;
};

export const convertAreaDataFromMshDataOld = (mshMasterFeatures, data) => {
  // const areaCodeMap = {};

  // for (const feature of features) {
  //   const { id, area_code } = feature.properties;
  //   if (!areaCodeMap[area_code]) {
  //     areaCodeMap[area_code] = [];
  //   }
  //   areaCodeMap[area_code].push(id);
  // }

  // メッシュのJSONをマスターとして字コードとメッシュコードの組み合わせで
  // [ {area_code: [msh_code01,msh_code02,msh_code03,msh_code04,msh_code05,msh_code06,msh_code07] }]
  // のような配列を作成する
  const areaCodeMap = {};
  for (const { properties: { id, area_code } } of mshMasterFeatures) {
    if (!areaCodeMap[area_code])
      areaCodeMap[area_code] = [];
    areaCodeMap[area_code].push(id);
  }

  // ② code → 値のマッピング作成（検索高速化）
  const valueMap = Object.fromEntries(data.map(v => [v.code, v]));

  // ③ area_code ごとに risk_val, h1_val の最大値を計算
  const result = Object.entries(areaCodeMap).map(([area_code, ids]) => {
    const risk_matrix = [];
    const h1_matrix = [];

    for (const id of ids) {
      const entry = valueMap[id];
      if (entry) {
        risk_matrix.push(entry.rsk_dc_value_num);
        h1_matrix.push(entry.h1_dc_value_num);
      }
    }

    const maxPerIndex = (matrix) => {
      if (matrix.length === 0) return [];
      const len = matrix[0].length;
      return Array.from({ length: len }, (_, i) =>
        Math.max(...matrix.map(row => row[i] ?? -Infinity))
      );
    };

    const city_code = String(area_code).slice(0, 5);

    return {
      code: Number(area_code),
      cityCode: Number(city_code),
      risk_val: maxPerIndex(risk_matrix),
      h1_val: maxPerIndex(h1_matrix),
    };
  });

  return result
}

export const convertCityDataFromMshDataOld = (mshMasterFeatures, data) => {
  // const areaCodeMap = {};

  // for (const feature of features) {
  //   const { id, area_code } = feature.properties;
  //   if (!areaCodeMap[area_code]) {
  //     areaCodeMap[area_code] = [];
  //   }
  //   areaCodeMap[area_code].push(id);
  // }

  // メッシュのJSONをマスターとして字コードとメッシュコードの組み合わせで
  // [ {area_code: [msh_code01,msh_code02,msh_code03,msh_code04,msh_code05,msh_code06,msh_code07] }]
  // のような配列を作成する
  const cityCodeMap = {};
  for (const { properties: { id, city_code } } of mshMasterFeatures) {
    if (!cityCodeMap[city_code])
      cityCodeMap[city_code] = [];
    cityCodeMap[city_code].push(id);
  }

  // ② code → 値のマッピング作成（検索高速化）
  const valueMap = Object.fromEntries(data.map(v => [v.code, v]));

  // ③ area_code ごとに risk_val, h1_val の最大値を計算
  const result = Object.entries(cityCodeMap).map(([city_code, ids]) => {
    const risk_matrix = [];
    const h1_matrix = [];

    for (const id of ids) {
      const entry = valueMap[id];
      if (entry) {
        risk_matrix.push(entry.risk_val);
        h1_matrix.push(entry.h1_val);
      }
    }

    const maxPerIndex = (matrix) => {
      if (matrix.length === 0) return [];
      const len = matrix[0].length;
      return Array.from({ length: len }, (_, i) =>
        Math.max(...matrix.map(row => row[i] ?? -Infinity))
      );
    };

    return {
      code: Number(city_code),
      risk_val: maxPerIndex(risk_matrix),
      h1_val: maxPerIndex(h1_matrix),
    };
  });

  return result
}

export const convertAreaDataSrFromMshData = (mshMasterFeatures, data) => {
  // const areaCodeMap = {};

  // for (const feature of features) {
  //   const { id, area_code } = feature.properties;
  //   if (!areaCodeMap[area_code]) {
  //     areaCodeMap[area_code] = [];
  //   }
  //   areaCodeMap[area_code].push(id);
  // }

  // メッシュのJSONをマスターとして字コードとメッシュコードの組み合わせで
  // [ {area_code: [msh_code01,msh_code02,msh_code03,msh_code04,msh_code05,msh_code06,msh_code07] }]
  // のような配列を作成する
  const areaCodeMap = {};
  for (const { properties: { id, area_code } } of mshMasterFeatures) {
    if (!areaCodeMap[area_code])
      areaCodeMap[area_code] = [];
    areaCodeMap[area_code].push(id);
  }

  // ② code → 値のマッピング作成（検索高速化）
  const valueMap = Object.fromEntries(data.map(v => [v.code, v]));

  // ③ area_code ごとに sr_lv, sr_val の最大値を計算
  const result = Object.entries(areaCodeMap).map(([area_code, ids]) => {
    const sr_lv_matrix = [];
    const sr_matrix = [];

    for (const id of ids) {
      const entry = valueMap[id];
      if (entry) {
        sr_lv_matrix.push(entry.sr_lv);
        sr_matrix.push(entry.sr_val);
      }
    }
    const maxPerIndex = (matrix) => {
      if (matrix.length === 0) return [];
      const len = matrix[0].length;
      return Array.from({ length: len }, (_, i) =>
        Math.max(...matrix.map(row => row[i] ?? -Infinity))
      );
    };
    const city_code = String(area_code).slice(0, 5);
    return {
      code: Number(area_code),
      cityCode: Number(city_code),
      sr_lv: maxPerIndex(sr_lv_matrix),
      sr_val: maxPerIndex(sr_matrix),
    };
  });

  return result
}

export const convertAreaDataSrRankFromMshData = (mshMasterFeatures, data) => {
  // const areaCodeMap = {};

  // for (const feature of features) {
  //   const { id, area_code } = feature.properties;
  //   if (!areaCodeMap[area_code]) {
  //     areaCodeMap[area_code] = [];
  //   }
  //   areaCodeMap[area_code].push(id);
  // }

  // メッシュのJSONをマスターとして市町村コードとメッシュコードの組み合わせで
  // [ {city_code: [msh_code01,msh_code02,msh_code03,msh_code04,msh_code05,msh_code06,msh_code07] }]
  // のような配列を作成する
  const cityCodeMap = {};
  for (const { properties: { id, city_code } } of mshMasterFeatures) {
    if (!cityCodeMap[city_code])
      cityCodeMap[city_code] = [];
    cityCodeMap[city_code].push(id);
  }

  // ② code → 値のマッピング作成（検索高速化）
  const valueMap = Object.fromEntries(data.map(v => [v.code, v]));

  // ③ city_code ごとに sr_lv, sr_val の最大値を計算
  const result = Object.entries(cityCodeMap).map(([city_code, ids]) => {
    const sr_lv_matrix = [];
    const sr_matrix = [];

    for (const id of ids) {
      const entry = valueMap[id];
      if (entry) {
        sr_lv_matrix.push(entry.sr_lv);
        sr_matrix.push(entry.sr_val);
      }
    }
    const maxPerIndex = (matrix) => {
      if (matrix.length === 0) return [];
      const len = matrix[0].length;
      return Array.from({ length: len }, (_, i) =>
        Math.max(...matrix.map(row => row[i] ?? -Infinity))
      );
    };
    return {
      code: Number(city_code),
      sr_lv: maxPerIndex(sr_lv_matrix),
      sr_val: maxPerIndex(sr_matrix),
    };
  });

  return result
}

export const convertAreaDataSrRainFromMshData = (mshMasterFeatures, data) => {
  // const areaCodeMap = {};

  // for (const feature of features) {
  //   const { id, area_code } = feature.properties;
  //   if (!areaCodeMap[area_code]) {
  //     areaCodeMap[area_code] = [];
  //   }
  //   areaCodeMap[area_code].push(id);
  // }

  // メッシュのJSONをマスターとして字コードとメッシュコードの組み合わせで
  // [ {area_code: [msh_code01,msh_code02,msh_code03,msh_code04,msh_code05,msh_code06,msh_code07] }]
  // のような配列を作成する
  const areaCodeMap = {};
  for (const { properties: { id, area_code } } of mshMasterFeatures) {
    if (!areaCodeMap[area_code])
      areaCodeMap[area_code] = [];
    areaCodeMap[area_code].push(id);
  }

  // ② code → 値のマッピング作成（検索高速化）
  const srValMap = Object.fromEntries(data.map(v => [v.code, v]));

  // ③ area_code ごとに sr_lv, sr_val の最大値を計算
  const result = Object.entries(areaCodeMap).map(([area_code, ids]) => {
    const sr_lv_matrix = [];
    const sr_val_matrix = [];
    const h1_val_matrix = [];
    const h24_val_matrix = [];

    for (const id of ids) {
      const srEntry = srValMap[id];
      if (srEntry) {
        sr_lv_matrix.push(srEntry.sr_lv);
        sr_val_matrix.push(srEntry.sr_val);
        h1_val_matrix.push(srEntry.h1_val);
        h24_val_matrix.push(srEntry.h24_val);
      }
    }
    const maxPerIndex = (matrix) => {
      if (matrix.length === 0) return [];
      const len = matrix[0].length;
      return Array.from({ length: len }, (_, i) =>
        Math.max(...matrix.map(row => row[i] ?? -Infinity))
      );
    };
    const city_code = String(area_code).slice(0, 5);
    return {
      code: Number(area_code),
      cityCode: Number(city_code),
      sr_lv: maxPerIndex(sr_lv_matrix),
      sr_val: maxPerIndex(sr_val_matrix),
      h1_val: maxPerIndex(h1_val_matrix),
      h24_val: maxPerIndex(h24_val_matrix),
    };
  });

  return result
}

export const convertAreaDataSrRainRankFromMshData = (mshMasterFeatures, data) => {
  // const areaCodeMap = {};

  // for (const feature of features) {
  //   const { id, area_code } = feature.properties;
  //   if (!areaCodeMap[area_code]) {
  //     areaCodeMap[area_code] = [];
  //   }
  //   areaCodeMap[area_code].push(id);
  // }

  // メッシュのJSONをマスターとして市町村コードとメッシュコードの組み合わせで
  // [ {city_code: [msh_code01,msh_code02,msh_code03,msh_code04,msh_code05,msh_code06,msh_code07] }]
  // のような配列を作成する
  const cityCodeMap = {};
  for (const { properties: { id, city_code } } of mshMasterFeatures) {
    if (!cityCodeMap[city_code])
      cityCodeMap[city_code] = [];
    cityCodeMap[city_code].push(id);
  }

  // ② code → 値のマッピング作成（検索高速化）
  const srValMap = Object.fromEntries(data.map(v => [v.code, v]));

  // ③ city_code ごとに sr_lv, sr_val の最大値を計算
  const result = Object.entries(cityCodeMap).map(([city_code, ids]) => {
    const sr_lv_matrix = [];
    const sr_val_matrix = [];
    const h1_val_matrix = [];
    const h24_val_matrix = [];

    for (const id of ids) {
      const srEntry = srValMap[id];
      if (srEntry) {
        sr_lv_matrix.push(srEntry.sr_lv);
        sr_val_matrix.push(srEntry.sr_val);
        h1_val_matrix.push(srEntry.h1_val);
        h24_val_matrix.push(srEntry.h24_val);
      }
    }
    const maxPerIndex = (matrix) => {
      if (matrix.length === 0) return [];
      const len = matrix[0].length;
      return Array.from({ length: len }, (_, i) =>
        Math.max(...matrix.map(row => row[i] ?? -Infinity))
      );
    };
    return {
      code: Number(city_code),
      sr_lv: maxPerIndex(sr_lv_matrix),
      sr_val: maxPerIndex(sr_val_matrix),
      h1_val: maxPerIndex(h1_val_matrix),
      h24_val: maxPerIndex(h24_val_matrix),
    };
  });

  return result
}

export const convertAreaDataRainMtrFromMshData = (mshMasterFeatures, data) => {
  const idToCityCodeMap = {};
  for (const { properties: { id, city_code } } of mshMasterFeatures) {
    idToCityCodeMap[id] = city_code;
  }

  // data.msh_code に一致する city_code を付ける
  return data.map(d => {
    const filteredFeatures = mshMasterFeatures.find(f =>
      f.properties.id === d.code
    )
    const lat_lng = getPolygonOrMultiPolygonCenter(filteredFeatures.geometry.coordinates)

    return {
      city_code: idToCityCodeMap[d.code] || null,
      sr_level: d.sr_level,
      sr_val: d.sr_val,
      h1h24_val: [d.h1_val, d.h24_val],
      h1_val: d.h1_val,
      h24_val: d.h24_val,
      name: d.name,
      address: d.address,
      date: d.date,
      area_lng: lat_lng[0],
      area_lat: lat_lng[1]
    }
  });
};

// export const convertAreaDataAccumFromMshData = (mshMasterFeatures, landslideRiskData, accumData) => {
//   const idToCityCodeMap = {};
//   const cityCodeToNameMap = {};

//   for (const { properties: { id, city_code, city_name } } of mshMasterFeatures) {
//     idToCityCodeMap[id] = city_code;
//     if (city_code && city_name) {
//       cityCodeToNameMap[city_code] = city_name;
//     }
//   }

//   const getMaxFromArray = (arr) => {
//     if (!Array.isArray(arr)) return null;
//     const valid = arr.filter(v => typeof v === 'number' && isFinite(v));
//     return valid.length > 0 ? Math.max(...valid) : null;
//   };

//   // code ごとの最大値を統合する
//   const mergedDataMap = {};

//   for (const d of accumData) {
//     const prev = mergedDataMap[d.code] || { code: d.code };
//     const maxAcm = getMaxFromArray(d.acm_val);

//     mergedDataMap[d.code] = {
//       ...prev,
//       acm_val: Math.max(prev.acm_val ?? -Infinity, maxAcm ?? -Infinity),
//     };
//   }

//   for (const r of landslideRiskData) {
//     const prev = mergedDataMap[r.code] || { code: r.code };

//     mergedDataMap[r.code] = {
//       ...prev,
//       risk_val: Math.max(prev.risk_val ?? -Infinity, r.risk_val ?? -Infinity),
//       h1_val: Math.max(prev.h1_val ?? -Infinity, r.h1_val ?? -Infinity),
//     };
//   }

//   const result = Object.values(mergedDataMap).map(d => {
//     const feature = mshMasterFeatures.find(f => f.properties.id === d.code);
//     const lat_lng = feature ? getPolygonOrMultiPolygonCenter(feature.geometry.coordinates) : [null, null];
//     const city_code = idToCityCodeMap[d.code] || null;
//     const city_name = city_code ? cityCodeToNameMap[city_code] || null : null;

//     const acm_val = isFinite(d.acm_val) ? d.acm_val : null;
//     const risk_val = isFinite(d.risk_val) ? d.risk_val : null;
//     const h1_val = isFinite(d.h1_val) ? d.h1_val : null;

//     return {
//       city_code,
//       acm_val,
//       risk_val,
//       h1_val,
//       h1_acm_val: [h1_val, acm_val],
//       name: city_name,
//       area_lng: lat_lng[0],
//       area_lat: lat_lng[1],
//     };
//   });

//   return result;
// };
export const convertAreaDataRainGaugeFromMshData = (mshMasterFeatures, data) => {
  const idToCityCodeMap = {};
  for (const { properties: { id, city_code } } of mshMasterFeatures) {
    idToCityCodeMap[id] = city_code;
  }

  // data.msh_code に一致する city_code を付ける
  return data.map(d => {
    const filteredFeatures = mshMasterFeatures.find(f =>
      f.properties.id === d.code
    )
    const lat_lng = getPolygonOrMultiPolygonCenter(filteredFeatures.geometry.coordinates)

    return {
      city_code: idToCityCodeMap[d.code] || null,
      sr_level: d.sr_level,
      sr_val: d.sr_val,
      h1h24_val: [d.h1_val, d.h24_val],
      h1_val: d.h1_val,
      h24_val: d.h24_val,
      name: d.name,
      address: d.address,
      date: d.date,
      area_lng: lat_lng[0],
      area_lat: lat_lng[1]
    }
  });
};

export const convertAreaDataAccumFromMshData = (mshMasterFeatures, data) => {
  const idToFeatureMap = {};
  for (const feature of mshMasterFeatures) {
    const id = feature.properties.id;
    idToFeatureMap[id] = feature;
  }

  // 一時格納用：city_code をキーにして統合
  const cityDataMap = {};

  for (const d of data) {
    const matchedFeature = idToFeatureMap[d.code];
    if (!matchedFeature) continue;

    const { city_code, city_name } = matchedFeature.properties;
    if (!city_code) continue;

    const lat_lng = getPolygonOrMultiPolygonCenter(matchedFeature.geometry.coordinates);
    const max_risk = Array.isArray(d.risk_val) ? Math.max(...d.risk_val) : null;
    const max_acm = Array.isArray(d.acm_val) ? Math.max(...d.acm_val) : null;
    const max_h1 = Array.isArray(d.h1_val) ? Math.max(...d.h1_val) : null;

    if (!cityDataMap[city_code]) {
      cityDataMap[city_code] = {
        msh_code: d.code, // 最初の msh_code を使う（代表）
        city_code,
        name: city_name || '',
        acm_val: max_acm,
        risk_val: max_risk,
        h1_val: max_h1,
        h1_acm_val: [max_h1, max_acm],
        area_lng: lat_lng[0],
        area_lat: lat_lng[1],
      };
    } else {
      // 既存の最大値と比較して更新
      const existing = cityDataMap[city_code];
      cityDataMap[city_code].acm_val = Math.max(existing.acm_val ?? -Infinity, max_acm ?? -Infinity);
      cityDataMap[city_code].risk_val = Math.max(existing.risk_val ?? -Infinity, max_risk ?? -Infinity);
      cityDataMap[city_code].h1_val = Math.max(existing.h1_val ?? -Infinity, max_h1 ?? -Infinity);
      cityDataMap[city_code].h1_acm_val = [
        cityDataMap[city_code].h1_val,
        cityDataMap[city_code].acm_val
      ];
    }
  }

  return Object.values(cityDataMap);
};

export const getMaxRiskH1ByCodeOld = (data, substrigLength = 0) => {

  const resultMap = {};

  data.forEach(({ code, risk_val, h1_val }) => {
    let groupCode = code
    if (substrigLength > 0)
      groupCode = String(code).slice(0, substrigLength); // 先頭5桁（例：11111）

    const maxRisk = Math.max(...risk_val.slice(6));
    const maxH1 = Math.max(...h1_val.slice(6));

    if (!resultMap[groupCode]) {
      resultMap[groupCode] = { code: Number(groupCode), risk_val: maxRisk, h1_val: maxH1 };
    } else {
      resultMap[groupCode].risk_val = Math.max(resultMap[groupCode].risk_val, maxRisk);
      resultMap[groupCode].h1_val = Math.max(resultMap[groupCode].h1_val, maxH1);
    }
  });

  // 最後に配列にして返す
  const result = Object.values(resultMap);
  return result;
};

export const getMaxLvSrByCode = (data, substrigLength = 0) => {

  const resultMap = {};
  data.forEach(({ code, sr_lv, sr_val }) => {
    let groupCode = code
    if (substrigLength > 0)
      groupCode = String(code).slice(0, substrigLength); // 先頭5桁（例：11111）

    const maxSrLv = Math.max(...sr_lv);
    const maxSr = Math.max(...sr_val);

    if (!resultMap[groupCode]) {
      resultMap[groupCode] = { code: Number(groupCode), sr_lv: maxSrLv, sr_val: maxSr };
    } else {
      resultMap[groupCode].sr_lv = Math.max(resultMap[groupCode].sr_lv, maxSrLv);
      resultMap[groupCode].sr_val = Math.max(resultMap[groupCode].sr_val, maxSr);
    }
  });

  // 最後に配列にして返す
  const result = Object.values(resultMap);
  return result;
};

export const getMaxLvSrRainByCode = (data, substrigLength = 0) => {

  const resultMap = {};
  data.forEach(({ code, sr_lv, sr_val, h1_val, h24_val }) => {
    let groupCode = code
    if (substrigLength > 0)
      groupCode = String(code).slice(0, substrigLength); // 先頭5桁（例：11111）

    const maxSrLv = Math.max(...sr_lv.slice(6));
    const maxSr = Math.max(...sr_val.slice(6));
    const maxH1 = Math.max(...h1_val.slice(6));
    const maxH24 = Math.max(...h24_val.slice(6));

    if (!resultMap[groupCode]) {
      resultMap[groupCode] = { code: Number(groupCode), sr_lv: maxSrLv, sr_val: maxSr, h1_val: maxH1, h24_val: maxH24 };
    } else {
      resultMap[groupCode].sr_lv = Math.max(resultMap[groupCode].sr_lv, maxSrLv);
      resultMap[groupCode].sr_val = Math.max(resultMap[groupCode].sr_val, maxSr);
      resultMap[groupCode].h1_val = Math.max(resultMap[groupCode].h1_val, maxH1);
      resultMap[groupCode].h24_val = Math.max(resultMap[groupCode].h24_val, maxH24);
    }
  });

  // 最後に配列にして返す
  const result = Object.values(resultMap);
  return result;
};

export const getMaxH1OfByCode = (data, substrigLength = 0) => {
  const resultMap = {};
  data.forEach(({ code, h1_val, of_val, diff }) => {
    let groupCode = code
    if (substrigLength > 0)
      groupCode = String(code).slice(0, substrigLength); // 先頭5桁（例：11111）

    const maxH1 = Math.max(...h1_val.slice(6));
    const maxOf = Math.max(...of_val.slice(6));
    const maxDiff = Math.max(...diff.slice(6));

    if (!resultMap[groupCode]) {
      resultMap[groupCode] = { code: Number(groupCode), h1_val: maxH1, of_val: maxOf, diff: maxDiff };
    } else {
      resultMap[groupCode].h1_val = Math.max(resultMap[groupCode].h1_val, maxH1);
      resultMap[groupCode].of_val = Math.max(resultMap[groupCode].of_val, maxOf);
      resultMap[groupCode].diff = Math.max(resultMap[groupCode].diff, maxDiff);
    }
  });

  // 最後に配列にして返す
  const result = Object.values(resultMap);
  return result;
};

export const getMaxH24OfByCode = (data, substrigLength = 0) => {
  const resultMap = {};
  data.forEach(({ code, h24_val, of_val, diff }) => {
    let groupCode = code
    if (substrigLength > 0)
      groupCode = String(code).slice(0, substrigLength); // 先頭5桁（例：11111）

    const maxH24 = Math.max(...h24_val.slice(6));
    const maxOf = Math.max(...of_val.slice(6));
    const maxDiff = Math.max(...diff.slice(6));

    if (!resultMap[groupCode]) {
      resultMap[groupCode] = { code: Number(groupCode), h24_val: maxH24, of_val: maxOf, diff: maxDiff };
    } else {
      resultMap[groupCode].h24_val = Math.max(resultMap[groupCode].h24_val, maxH24);
      resultMap[groupCode].of_val = Math.max(resultMap[groupCode].of_val, maxOf);
      resultMap[groupCode].diff = Math.max(resultMap[groupCode].diff, maxDiff);
    }
  });

  // 最後に配列にして返す
  const result = Object.values(resultMap);
  return result;
};

export const getMaxRoadByCode = (data, substrigLength = 0) => {

  const resultMap = {};

  data.forEach(({ code, h1_val, lv, of_val, rsk_val, }) => {
    let groupCode = code
    if (substrigLength > 0)
      groupCode = String(code).slice(0, substrigLength); // 先頭5桁（例：11111）

    const maxH1 = Math.max(...h1_val.slice(6));
    const maxLv = Math.max(...lv.slice(6));
    const maxOf = Math.max(...of_val.slice(6));
    const maxRisk = Math.max(...rsk_val.slice(6));

    if (!resultMap[groupCode]) {
      resultMap[groupCode] = { code: Number(groupCode), lv: maxLv, h1_val: maxH1, of_val: maxOf, rsk_val: maxRisk };
    } else {
      resultMap[groupCode].lv = Math.max(resultMap[groupCode].lv, maxLv);
      resultMap[groupCode].h1_val = Math.max(resultMap[groupCode].h1_val, maxH1);
      resultMap[groupCode].of_val = Math.max(resultMap[groupCode].of_val, maxH1);
      resultMap[groupCode].rsk_val = Math.max(resultMap[groupCode].rsk_val, maxRisk);
    }
  });

  // 最後に配列にして返す
  const result = Object.values(resultMap);
  return result;
};

/**
 * 全日時断面のリスクに地域情報を付与する
 * @param {Object} features - 地域情報取得用のデータ
 * @param {Object} data - 全日時断面のリスクデータ
 * @returns {Array} 全日時断面のリスクと地域情報
 */
export const getAllByDateTimeWithAreaInfo = (features, data) => {
  const result = data.map(item => {
    const area_code = item.code
    // 対象字コードの feature を抽出
    const filteredFeatures = features.find(f =>
      f.properties.id === area_code
    );
    // featureから字名を取得
    const area_name = filteredFeatures.properties.name

    // featureから緯度経度を取得
    const lat_lng = getMultiPolygonCenter(filteredFeatures.geometry.coordinates)
    const area_lng = lat_lng[0]
    const area_lat = lat_lng[1]
    const risk_val = item.rsk_dc_value_num
    return { area_code, area_name, area_lat, area_lng, risk_val };
  });
  return result
};

/**
 * 全日時断面のリスクに地域情報を付与する
 * @param {Object} features - 地域情報取得用のデータ
 * @param {Object} data - 全日時断面のリスクデータ
 * @returns {Array} 全日時断面のリスクと地域情報
 */
export const getAllByDateTimeWithAreaRiskInfo = (features, data) => {
  const result = data.map(item => {
    const area_code = item.code
    // 対象字コードの feature を抽出
    const filteredFeatures = features.find(f =>
      f.properties.id === area_code
    );
    // featureから字名を取得
    const area_name = filteredFeatures.properties.name

    // featureから緯度経度を取得
    const lat_lng = getMultiPolygonCenter(filteredFeatures.geometry.coordinates)
    const area_lng = lat_lng[0]
    const area_lat = lat_lng[1]
    const risk_val = item.soil_index_level
    return { area_code, area_name, area_lat, area_lng, risk_val };
  });
  return result
};

/**
 * 全日時断面のリスクに地域情報を付与する
 * @param {Object} features - 地域情報取得用のデータ
 * @param {Object} data - 全日時断面のリスクデータ
 * @returns {Array} 全日時断面のリスクと地域情報
 */
export const getAllByDateTimeWithAreaInfoH1 = (features, data) => {
  const result = data.map(item => {
    const area_code = item.code
    // 対象字コードの feature を抽出
    const filteredFeatures = features.find(f =>
      f.properties.id === area_code
    );
    // featureから字名を取得
    const area_name = filteredFeatures.properties.name

    // featureから緯度経度を取得
    const lat_lng = getMultiPolygonCenter(filteredFeatures.geometry.coordinates)
    const area_lng = lat_lng[0]
    const area_lat = lat_lng[1]
    const h1_val = item.h1_dc_value_num
    return { area_code, area_name, area_lat, area_lng, h1_val };
  });
  return result
};

/**
 * 全日時断面のリスクに地域情報を付与する
 * @param {Object} features - 地域情報取得用のデータ
 * @param {Object} data - 全日時断面のリスクデータ
 * @returns {Array} 全日時断面のリスクと地域情報
 */
export const getAllByDateTimeWithCityInfo = (features, data) => {
  const result = data.map(item => {
    const city_code = item.code
    // 対象字コードの feature を抽出
    const filteredFeatures = features.find(f =>
      f.properties.city_code === city_code
    );
    // featureから字名を取得
    const city_name = filteredFeatures.properties.city_name

    // featureから緯度経度を取得
    const lat_lng = getMultiPolygonCenter(filteredFeatures.geometry.coordinates)
    const area_lng = lat_lng[0]
    const area_lat = lat_lng[1]
    const risk_val = item.risk_val
    return { city_code, city_name, area_lat, area_lng, risk_val };
  });
  return result
};

/**
 * 全日時断面のリスクに地域情報を付与する
 * @param {Object} features - 地域情報取得用のデータ
 * @param {Object} data - 全日時断面のリスクデータ
 * @returns {Array} 全日時断面のリスクと地域情報
 */
export const getAllByDateTimeWithSrAreaInfo = (features, data) => {
  const result = data.map(item => {
    const city_code = item.code
    // 対象字コードの feature を抽出
    const filteredFeatures = features.find(f =>
      f.properties.city_code === city_code
    );
    const city_name = filteredFeatures.properties.city_name
    // featureから緯度経度を取得
    const coordinates = filteredFeatures.geometry.coordinates;
    const lat_lng = getMultiPolygonCenter([coordinates]);
    const area_lng = lat_lng[0]
    const area_lat = lat_lng[1]
    const sr_lv = item.sr_lv
    const sr_val = item.sr_val
    return { city_code, city_name, area_lat, area_lng, sr_lv, sr_val };
  });
  return result
};

/**
 * 全日時断面のリスクに地域情報を付与する
 * @param {Object} features - 地域情報取得用のデータ
 * @param {Object} data - 全日時断面のリスクデータ
 * @returns {Array} 全日時断面のリスクと地域情報
 */
export const getAllByDateTimeWithRoadAreaInfo = (features, data) => {
  const result = [];
  data.forEach(item => {
    const msh_code = item.code;

    // 対象 msh_code の feature を抽出
    const filteredFeature = features.find(f => f.properties.msh_code === msh_code);
    if (!filteredFeature) return;

    // 道路名をカンマで分割し、トリムして配列化
    const txtRoadNames = filteredFeature.properties.txt_road_name
      .split(',')
      .map(name => name.trim())
      .filter(name => name.length > 0); // 空文字を除外

    const city_name = filteredFeature.properties.city_name;
    const coordinates = filteredFeature.geometry.coordinates;
    const [area_lng, area_lat] = getMultiPolygonCenter([coordinates]);

    const lv = item.lv;
    const h1_val = item.h1_val;
    const of_val = item.of_val;
    const rsk_val = item.rsk_val;

    // 道路名ごとにオブジェクトを複製して追加
    txtRoadNames.forEach(txt_road_name => {
      result.push({
        msh_code,
        city_name,
        txt_road_name,
        area_lat,
        area_lng,
        lv,
        h1_val,
        of_val,
        rsk_val
      });
    });
  });

  return result;
};

export const getMaxVal = (code_ary, data) => {

  const grouped = {};
  Object.entries(data).forEach(([key, values]) => {
    const [prefix, codeStr] = key.split('_val_');
    const code = Number(codeStr);
    const maxVal = Math.max(...values.filter(v => v != null)); // null を除外

    if (!grouped[code]) {
      grouped[code] = { code };
    }

    grouped[code][`${prefix}_val`] = maxVal;
  });

  // 全データを配列に変換
  const all_data = Object.values(grouped);
  // 必要なコードのもののみ抽出
  const result = all_data.filter(item =>
    code_ary.includes(item.code)
  );
  return result
}

export const getTelIsCurrentVal = (code_ary, apiData) => {
  return apiData
    .filter(d => code_ary.includes(d.code))
    .map(d => {
      const validIndexes = d.is_current
        .map((flag, index) => flag === 1 ? index : -1)
        .filter(index => index !== -1);

      return {
        ...d,
        risk_val: validIndexes.map(i => d.risk_val[i]),
        pct_val: validIndexes.map(i => d.pct_val[i]),
        mtr_val: validIndexes.map(i => d.mtr_val[i]),
        is_current: validIndexes.map(() => 1)
      };
    });
};

export const getMaxListTel = (data, substrigLength = 0) => {
  const resultMap = {};
  data.forEach(({ code, mtr_val, pct_val, risk_val }) => {
    let groupCode = code
    if (substrigLength > 0)
      groupCode = String(code).slice(0, substrigLength); // 先頭5桁（例：11111）

    if (!resultMap[groupCode]) {
      resultMap[groupCode] = { code: Number(groupCode), mtr_val: Math.max(...mtr_val), pct_val: Math.max(...pct_val), risk_val: Math.max(...risk_val) };
    } else {
      resultMap[groupCode].mtr_val = Math.max(resultMap[groupCode].mtr_val, Math.max(...mtr_val));
      resultMap[groupCode].pct_val = Math.max(resultMap[groupCode].pct_val, Math.max(...pct_val));
      resultMap[groupCode].risk_val = Math.max(resultMap[groupCode].risk_val, Math.max(...risk_val));
    }
  });

  // 最後に配列にして返す
  const result = Object.values(resultMap);
  return result;
};

/**
 * 全日時断面のリスクと地域情報を取得
 * @param {Array} code_ary - 選択地域
 * @param {Object} srApiData - APIから取得したデータ
 * @param {Object} rainApiData - APIから取得したデータ
 * @param {boolean} isH6 - 6時間モードかどうか
 * @returns {Array} 全日時断面のリスクと1時間雨量
 */
export const getAllByAccumDateTime = (code_ary, mshLideslideApiData, accumApiData, isH6) => {
  const grouped = {};
  // 共通処理化する関数
  const processApiData = (apiData) => {
    for (const key in apiData) {
      const match = key.match(/(.+?)_val_(\d+)/); // ← _val_ のみ対応
      if (!match) continue;

      const prefix = match[1];
      const code = match[2];

      if (!grouped[code]) {
        grouped[code] = { code: Number(code) };
      }

      let val = apiData[key];

      if (isH6) {
        val = Array.isArray(val) ? val.slice(0, -9) : val;
      }

      grouped[code][`${prefix}_val`] = val;
    }
  };
  // 両方の API データを処理
  processApiData(mshLideslideApiData);
  processApiData(accumApiData);

  // フィルタして必要なコードだけ返す
  const result = Object.values(grouped).filter(item =>
    code_ary.includes(item.code)
  );

  return result;
};

/**
 * 全日時断面のリスクと地域情報を取得
 * @param {Array} code_ary - 選択地域
 * @param {Object} apiData - APIから取得したデータ
 * @param {boolean} isH6 - 6時間モードかどうか
 * @returns {Array} 全日時断面のリスクと1時間雨量
 */
export const getAllByRoadDateTime = (code_ary, apiData) => {
  const grouped = {};

  for (const key in apiData) {
    // 'prefix_type_code' または 'type_code' の形式に対応
    let match = key.match(/(.+?)_(lv|val)_(\d+)/);
    let prefix, type, code;

    if (match) {
      prefix = match[1];
      type = match[2];
      code = match[3];
    } else {
      match = key.match(/^(lv|val)_(\d+)$/);
      if (!match) continue;

      prefix = '';
      type = match[1];
      code = match[2];
    }

    if (!grouped[code]) {
      grouped[code] = { code: Number(code) };
    }

    const val = apiData[key];
    const keyName = prefix ? `${prefix}_${type}` : type;

    grouped[code][keyName] = val;
  }

  const result = Object.values(grouped).filter(item =>
    code_ary.includes(item.code)
  );

  return result;
};


// get max perIndex
const maxPerIndex = (matrix) => {
    if (!matrix.length) return [];
    const len = matrix[0].length;
    const result = Array(len).fill(-Infinity);
    for (const row of matrix) {
        for (let i = 0; i < len; i++) {
            if (row[i] > result[i]) result[i] = row[i];
        }
    }
    return result;
};
/**
 * Aggregates mesh-level risk data into area-level data
 * - Groups mesh IDs by area_code
 * - Takes maximum value per time index
 *
 * @param {Array} mshMasterFeatures - mesh geo features
 * @param {Array} data - mesh risk data
 * @returns {Array} area-based risk data
 */
export const convertAreaDataFromMshData = (mshMasterFeatures, data) => {
    // のような配列を作成する
    const areaCodeMap = {};
    for (const { properties: { id, area_code } } of mshMasterFeatures) {
        if (!areaCodeMap[area_code])
            areaCodeMap[area_code] = [];
        areaCodeMap[area_code].push(id);
    }

    // ② code → 値のマッピング作成（検索高速化）
    const valueMap = Object.fromEntries(data.map(v => [v.code, v]));

    // ③ area_code ごとに risk_val, h1_val の最大値を計算
    const result = Object.entries(areaCodeMap).map(([area_code, ids]) => {
        const rsk_dc_value_num = [];
        const dc_tank_of_num = [];
        const h1_dc_value_num = [];
        const h24_dc_value_num = [];
        const h48_dc_value_num = [];
        const soil_index_level = [];

        for (const id of ids) {
            const entry = valueMap[id];
            if (entry) {
                rsk_dc_value_num.push(entry.rsk_dc_value_num);
                dc_tank_of_num.push(entry.dc_tank_of_num);
                h1_dc_value_num.push(entry.h1_dc_value_num);
                h24_dc_value_num.push(entry.h24_dc_value_num);
                h48_dc_value_num.push(entry.h48_dc_value_num);
                soil_index_level.push(entry.soil_index_level);
            }
        }

        const city_code = String(area_code).slice(0, 5);

        return {
            code: Number(area_code),
            city_code: Number(city_code),
            rsk_dc_value_num: maxPerIndex(rsk_dc_value_num),
            dc_tank_of_num: maxPerIndex(dc_tank_of_num),
            h1_dc_value_num: maxPerIndex(h1_dc_value_num),
            h24_dc_value_num: maxPerIndex(h24_dc_value_num),
            h48_dc_value_num: maxPerIndex(h48_dc_value_num),
            soil_index_level: maxPerIndex(soil_index_level),
        };
    });

    return result
}


/**
 * Aggregates mesh-level risk data into city-level data
 * - Groups by city_code
 * - Takes maximum value per time index
 *
 * @param {Array} mshMasterFeatures
 * @param {Array} data
 * @returns {Array} city-based risk data
 */
export const convertCityDataFromMshData = (mshMasterFeatures, data) => {
    const cityCodeMap = {};
    for (const { properties: { id, city_code } } of mshMasterFeatures) {
        if (!cityCodeMap[city_code])
            cityCodeMap[city_code] = [];
        cityCodeMap[city_code].push(id);
    }

    // ② code → 値のマッピング作成（検索高速化）
    const valueMap = Object.fromEntries(data.map(v => [v.code, v]));

    // ③ area_code ごとに risk_val, h1_val の最大値を計算
    const result = Object.entries(cityCodeMap).map(([city_code, ids]) => {
        const risk_matrix = [];
        const dc_tank_matrix = [];
        const h1_matrix = [];
        const h24_matrix = [];
        const h48_matrix = [];
        const soil_index_level_matrix = [];

        for (const id of ids) {
            const entry = valueMap[id];
            if (entry) {
                risk_matrix.push(entry.rsk_dc_value_num);
                dc_tank_matrix.push(entry.dc_tank_of_num);
                h1_matrix.push(entry.h1_dc_value_num);
                h24_matrix.push(entry.h24_dc_value_num);
                h48_matrix.push(entry.h48_dc_value_num);
                soil_index_level_matrix.push(entry.soil_index_level);
            }
        }
        return {
            code: Number(city_code),
            risk_val: maxPerIndex(risk_matrix),
            dc_tank_val: maxPerIndex(dc_tank_matrix),
            h1_val: maxPerIndex(h1_matrix),
            h24_val: maxPerIndex(h24_matrix),
            h48_val: maxPerIndex(h48_matrix),
            soil_index_level: maxPerIndex(soil_index_level_matrix),
        };
    });

    return result
}

/**
 * Calculates maximum H1 risk per code group
 * - Supports grouping by substring (city, area, mesh)
 *
 * @param {Array} data
 * @param {number} substringLength
 * @returns {Array}
 */
export const getMaxRiskH1ByCode = (data, substringLength = 0) => {
    const resultMap = {};
    data.forEach(({ code, rsk_dc_value_num, h1_dc_value_num }) => {
        let groupCode = code
        if (substringLength > 0)
            groupCode = String(code).slice(0, substringLength); // 先頭5桁（例：11111）

        const maxRisk = Math.max(...rsk_dc_value_num.slice(6));
        const maxH1 = Math.max(...h1_dc_value_num.slice(6));

        if (!resultMap[groupCode]) {
            resultMap[groupCode] = { code: Number(groupCode), risk_val: maxRisk, h1_val: maxH1 };
        } else {
            resultMap[groupCode].risk_val = Math.max(resultMap[groupCode].risk_val, maxRisk);
            resultMap[groupCode].h1_val = Math.max(resultMap[groupCode].h1_val, maxH1);
        }
    });

    // 最後に配列にして返す
    const result = Object.values(resultMap);
    return result;
};

// 更新日時（TSM_RECEPT_DATE_SUM）ごとに被害件数を集計し、日時順に並べて返す
// data: クロノロジーデータ配列
// limit: 取得上限（省略可）
export const getChronologyTimeRankWithLimit = (data, limit) => {
  if (!Array.isArray(data)) return [];
  const labelKeys = {
    int_collapse_num: 'int_collapse_num',
    int_landslide_num: 'int_landslide_num',
    int_flood_num: 'int_flood_num',
    int_fallen_tree_num: 'int_fallen_tree_num',
    int_power_outage_num: 'int_power_outage_num',
    int_water_outage_num: 'int_water_outage_num',
    int_other_num: 'int_other_num',
    int_human_num: 'int_human_num',
    int_regulation_num: 'int_regulation_num',
    int_river_burst_num: 'int_river_burst_num'
  };

  const parseToTime = (raw) => {
    if (raw === null || raw === undefined) return Infinity;
    const s = String(raw).trim();
    const m = s.match(/^\s*(\d{1,2})\/(\d{1,2})\s+(\d{1,2}):(\d{2})\s*$/);
    const year = new Date().getFullYear();
    if (m) {
      const month = Number(m[1]) - 1;
      const day = Number(m[2]);
      const hour = Number(m[3]);
      const minute = Number(m[4]);
      return new Date(year, month, day, hour, minute).getTime();
    }
    const d = new Date(s);
    if (!isNaN(d.getTime())) return d.getTime();
    return Infinity;
  };

  const map = {}; // normalizedDate -> aggregation
  for (const item of data) {
    if (!item) continue;
    const key = item?.tsm_update_date_sum ??  item?.tsm_update_date ;
    if (!map[key]) {
      map[key] = { 
        date: key, 
        total: 0,
        codes: [],
        msh_code: []
      };
      // init damage counters (lower-case keys to match other functions)
      Object.keys(labelKeys).forEach(k => { map[key][k] = 0; });
    }

    if (item.code) {
      map[key].codes.push(item.code);
    }

    if(item.msh_code){
      map[key].msh_code.push(item.msh_code);
    }

    // 全体合計（INT_ALL_NUM）を加算
    map[key].total += Number(item.int_all_num) || 0;

    // 各被害種別を加算（原データの大文字キーを参照）
    Object.entries(labelKeys).forEach(([outKey, rawKey]) => {
      map[key][outKey] += Number(item[rawKey]) || 0;
    });
  }
  // 配列化して日時順（昇順）にソート
  let ary = Object.values(map).sort((a, b) => {
    const ta = parseToTime(a.date);
    const tb = parseToTime(b.date);
    return tb - ta;
  });

  if (typeof limit === 'number' && limit > 0) {
    ary = ary.slice(0, limit);
  }
  return ary;
};

// 被害種別ラベル配列（getChronologyValueList と同順。0件の種別は除外）
export const getChronologyLabelList = (data) => {
  if (!Array.isArray(data) || data.length === 0) return [];
  const keyList = [
    'int_collapse_num',
    'int_landslide_num',
    'int_flood_num',
    'int_fallen_tree_num',
    'int_power_outage_num',
    'int_water_outage_num',
    'int_other_num',
    'int_human_num',
    'int_regulation_num',
    'int_river_burst_num'
  ];
  const labelMap = {
    int_collapse_num: '崩壊・損傷',
    int_landslide_num: '土砂崩れ',
    int_flood_num: '冠水・浸水',
    int_fallen_tree_num: '倒木',
    int_power_outage_num: '停電・断線',
    int_water_outage_num: '断水・破断',
    int_other_num: 'その他被害',
    int_human_num: '人的被害',
    int_regulation_num: '交通規制',
    int_river_burst_num: '決壊'
  };

  const totals = Object.fromEntries(keyList.map(k => [k, 0]));

  for (const item of data) {
    if (!item) continue;
    for (const key of keyList) {
      const n = Number(item[key]);
      if (Number.isFinite(n) && n > 0) totals[key] += n;
    }
  }

  const labels = [];
  for (const key of keyList) {
    if (totals[key] && totals[key] > 0) labels.push(labelMap[key] || key);
  }
  return labels;
};

// 被害種別ごとの合計件数配列（0件の種別は除外して返す）
export const getChronologyValueList = (data) => {
  if (!Array.isArray(data) || data.length === 0) return [];
    const keyList = [
    'int_collapse_num',
    'int_landslide_num',
    'int_flood_num',
    'int_fallen_tree_num',
    'int_power_outage_num',
    'int_water_outage_num',
    'int_other_num',
    'int_human_num',
    'int_regulation_num',
    'int_river_burst_num'
  ];

  const totals = Object.fromEntries(keyList.map(k => [k, 0]));

  for (const item of data) {
    if (!item) continue;
    for (const key of keyList) {
      const n = Number(item[key]);
      if (Number.isFinite(n) && n > 0) totals[key] += n;
    }
  }

  // 0件のカテゴリは除外して配列で返す（チャートの series 用）
  const values = [];
  for (const key of keyList) {
    if (totals[key] && totals[key] > 0) values.push(totals[key]);
  }
  return values;
};

export const getAllByCodeNotNull = (data, isH6) => {
  if (!Array.isArray(data)) return [];
  return data.filter(item => item && item.code !== null && item.code !== undefined);
};

//City
export const getChronologyRankWithLimit = (data, limit) => {
  if (!Array.isArray(data)) return [];

  const labelKeys = {
    int_collapse_num: 'int_collapse_num',
    int_landslide_num: 'int_landslide_num',
    int_flood_num: 'int_flood_num',
    int_fallen_tree_num: 'int_fallen_tree_num',
    int_power_outage_num: 'int_power_outage_num',
    int_water_outage_num: 'int_water_outage_num',
    int_other_num: 'int_other_num',
    int_human_num: 'int_human_num',
    int_regulation_num: 'int_regulation_num',
    int_river_burst_num: 'int_river_burst_num'
  };

  const map = {}; // city_code -> aggregation
  data.forEach(item => {
    const city = item.city_code || item.city_name || '__unknown__';
    if (!map[city]) {
      map[city] = {
        city_code: item.city_code || null,
        city_name: item.city_name || (item.city_code ? String(item.city_code) : '不明'),
        area_lat: item.dc_lat_num || null,
        area_lng: item.dc_lng_num || null,
        total: 0
      };
      // init damage counters
      Object.keys(labelKeys).forEach(k => { map[city][k] = 0; });
    }
    // 全体合計（INT_ALL_NUM）を加算
    // map[city].total += Number(item.int_all_num) || 0;
    
    // 各被害種別を加算
    Object.entries(labelKeys).forEach(([outKey, rawKey]) => {
      map[city][outKey] += Number(item[rawKey]) || 0;
      map[city].total += Number(item[rawKey]) || 0;
    });
    // keep lat/lng if missing
    if (!map[city].area_lat && item.dc_lat_num) map[city].area_lat = item.dc_lat_num;
    if (!map[city].area_lng && item.dc_lng_num) map[city].area_lng = item.dc_lng_num;
  });

  const ary = Object.values(map)
    .sort((a, b) => b.total - a.total)
    .slice(0, limit);

  return ary;
};


// 選択地域のKeyNameを全て取得し、合計件数（単一の数値）を返す
export const getKeyNameCountByDateTime = (data, keyName) => {
  const valuesRaw = (data || [])
    .map(item => (item ? item[keyName] : undefined))
    .filter(v => v !== null && v !== undefined);

  if (valuesRaw.length === 0) return 0;

  let sum = 0;
  valuesRaw.forEach(v => {
    // 数値変換して有効な数なら加算、そうでなければ無視
    const n = Number(v);
    if (Number.isFinite(n)) sum += n;
  });

  return sum;
};

// 被害種別ラベル & 件数をまとめて取得（0件除外・件数DESCソート）
export const getChronologyPieData = (data) => {
  if (!Array.isArray(data) || data.length === 0) {
    return { labels: [], values: [] }
  }

  const keyList = [
    'int_collapse_num',
    'int_landslide_num',
    'int_flood_num',
    'int_fallen_tree_num',
    'int_power_outage_num',
    'int_water_outage_num',
    'int_other_num',
    'int_human_num',
    'int_regulation_num',
    'int_river_burst_num'
  ]

  const labelMap = {
    int_collapse_num: '崩壊・損傷',
    int_landslide_num: '土砂崩れ',
    int_flood_num: '冠水・浸水',
    int_fallen_tree_num: '倒木',
    int_power_outage_num: '停電・断線',
    int_water_outage_num: '断水・破断',
    int_other_num: 'その他被害',
    int_human_num: '人的被害',
    int_regulation_num: '交通規制',
    int_river_burst_num: '決壊'
  }

  // 初期化
  const totals = Object.fromEntries(keyList.map(k => [k, 0]))

  // 合計計算（1回だけ）
  for (const item of data) {
    if (!item) continue
    for (const key of keyList) {
      const n = Number(item[key])
      if (Number.isFinite(n) && n > 0) {
        totals[key] += n
      }
    }
  }

  // 0件除外 → 配列化 → DESCソート
  const sorted = Object.entries(totals)
    .filter(([, total]) => total > 0)
    .sort((a, b) => b[1] - a[1])

  return {
    labels: sorted.map(([key]) => labelMap[key] ?? key),
    values: sorted.map(([, total]) => total),
  }
}

export const getShelterCodeByCityCode = (data, code_ary) => {
  if (!Array.isArray(data) || !Array.isArray(code_ary) || code_ary.length === 0) return [];

  const cityCodeSet = new Set(code_ary.map(city_code => String(city_code ?? '').trim()).filter(city_code => city_code !== ''));
  const idSet = new Set();

  data.forEach(item => {
    if (!item) return;
    const itemCityCode = String(item.city_code ?? '').trim();
    if (!itemCityCode) return;
    if (cityCodeSet.has(itemCityCode)) {
      const id = Number(item.id);
      if (!isNaN(id)) idSet.add(id);
      else if (item.id !== undefined && item.id !== null) idSet.add(item.id);
    }
  });

  return Array.from(idSet);
};

// 避難所分析のshelter_codeを基にcity_code全て取得した配列で返す
export const getCityCodeByShelterCode = (data, code_ary) => {
  if (!Array.isArray(data) || !Array.isArray(code_ary) || code_ary.length === 0) return [];

  const idSet = new Set(code_ary.map(id => String(id ?? '').trim()).filter(id => id !== ''));
  const citySet = new Set();

  data.forEach(item => {
    if (!item) return;
    const itemId = String(item.id ?? '').trim();
    if (!itemId) return;
    if (idSet.has(itemId)) {
      const city = Number(item.city_code);
      if (!isNaN(city)) citySet.add(city);
      else if (item.city_code !== undefined && item.city_code !== null) citySet.add(item.city_code);
    }
  });

  return Array.from(citySet);
};

export const getAllByShelterCode = (code_ary, apiData) => {
  let all_data = apiData
  // 必要なコードのもののみ抽出
  const result = all_data.filter(item =>
    code_ary.includes(item.id)
  );
  return result
};

export const getAllByCityCode = (code_ary, apiData, isH6) => {
  let all_data = apiData
  // 6時間モードの場合０番目から12番目までの値
  if (isH6) {
    all_data = apiData.map(item => {
      const newItem = { code: item.city_code };

      for (const [key, value] of Object.entries(item)) {
        if (Array.isArray(value)) {
          newItem[key] = value.slice(0, -9); // 配列なら末尾9つカット
        }
      }

      return newItem;
    });
  }
  // 必要なコードのもののみ抽出
  const result = all_data.filter(item =>
    code_ary.includes(item.city_code)
  );
  return result
};

// 選択地域のKeyNameを全て取得したデータを返す
export const getShelterAnalysisList = (data) => {
  if (!Array.isArray(data)) return [];

  const pickHasClose = (a, b) => {
    const aHas = a && a.close_time !== null && a.close_time !== undefined && String(a.close_time).trim() !== '';
    const bHas = b && b.close_time !== null && b.close_time !== undefined && String(b.close_time).trim() !== '';
    if (aHas && !bHas) return a;
    if (!aHas && bHas) return b;
    if (aHas && bHas) {
      const ta = Date.parse(String(a.close_time));
      const tb = Date.parse(String(b.close_time));
      if (!isNaN(ta) && !isNaN(tb)) {
        return tb > ta ? b : a;
      }
      return b; // 両方あるが解析できなければ後の方を優先
    }
    return a; // 両方ない場合は最初のものを保持
  };

  const map = new Map();
  for (const item of data) {
    if (!item) continue;
    const id = item.id ?? item.ID ?? item.shelter_id ?? null;
    if (!id) continue;
    if (!map.has(id)) {
      map.set(id, item);
    } else {
      const current = map.get(id);
      map.set(id, pickHasClose(current, item));
    }
  }

  return Array.from(map.values());
};

// 選択地域のKeyNameを全て取得したデータを返す
export const getKeyNameList = (data, keyName) => {
  if (!Array.isArray(data)) return [];
  return data.filter(item => item && item.txt_sort_name === keyName);
};

export const getNeedInspectionList = (data) => {
  if (!Array.isArray(data)) return [];
  return data.filter(item => item && item.is_damge_count == 1);
};


/**
 * - 引数: data: 避難所オブジェクト配列, limit: 上位件数(デフォルト200)
 * - 処理: data を "開設" に絞り、city_code ごとに int_hdcnt_num を合計して降順ソート
 * - 返却: [{ city_code, city_name, dc_lat_num, dc_lng_num, int_hdcnt_num }, ...]
 */
export function getEvacRankWithLimit(data, limit) {
    if (!Array.isArray(data) || data.length === 0) return [];

    // "開設" に該当するレコードに絞る（txt_sort_name または status_category_name を参照）
    const opened = data.filter(item => {
        const sortName = String(item?.txt_sort_name ?? '').trim();
        const statusName = String(item?.status_category_name ?? '').trim();
        return sortName === '開設' || statusName.indexOf('開設') !== -1;
    });

    // city_code ごとに集計（代表的な city_name / 緯度経度は最初の出現を使う）
    const groups = {};
    for (const it of opened) {
        const cid = it?.city_code;
        if (cid == null) continue;
        const key = String(cid);
        const val = Number(it?.int_hdcnt_num) || 0;
        if (!groups[key]) {
            groups[key] = {
                city_code: Number(cid),
                city_name: it?.txt_city_name ?? '',
                area_lat: it?.dc_lat_num ?? null,
                area_lng: it?.dc_lng_num ?? null,
                evac_total: 0
            };
        }
        groups[key].evac_total += val;

        // もし緯度経度が未設定なら後続の値で補完する
        if ((groups[key].area_lat == null || groups[key].area_lng == null) && (it?.dc_lat_num != null && it?.dc_lng_num != null)) {
            groups[key].area_lat = it.dc_lat_num;
            groups[key].area_lng = it.dc_lng_num;
        }
    }

    // 配列化してソート（合計降順、同値なら city_code 昇順）
    const ary = Object.values(groups)
        .map(g => ({
            city_code: g.city_code,
            city_name: g.city_name,
            area_lat: g.area_lat,
            area_lng: g.area_lng,
            evac_total: Number(g.evac_total) || 0
        }))
        .sort((a, b) => {
            if (b.evac_total !== a.evac_total) return b.evac_total - a.evac_total;
            return String(a.city_code).localeCompare(String(b.city_code));
        });

    return ary.slice(0, limit);
}

export const getShelterAnalysisRankWithLimit = (data, liimit, rankKey) => {
  if (!Array.isArray(data)) return [];
  const limit = typeof liimit === 'number' ? liimit : parseInt(liimit, 10) || 0;
  if (limit <= 0) return [];

  const getFieldNumber = (item, key) => {
    if (!item) return 0;
    const tryKeys = [key, key.toUpperCase(), key.toLowerCase()];
    for (const k of tryKeys) {
      const v = item[k];
      if (v !== undefined && v !== null && v !== '') return Number(v) || 0;
    }
    return 0;
  };

  const getId = (item) => {
    if (!item) return null;
    return item.id ?? item.code ?? item.shelter_code ?? item.shelterCode ?? item.ID ?? null;
  };

  const groups = {};
  for (const it of data) {
    if (!it) continue;
    const idVal = getId(it);
    if (idVal == null) continue;
    const key = String(idVal);
    const addVal = getFieldNumber(it, rankKey);

    if (!groups[key]) {
      groups[key] = {
        id: idVal,
        code: idVal,
        city_code: it.city_code ?? it.cityCode ?? null,
        txt_city_name: it.txt_city_name ?? it.txtCityName ?? '',
        txt_area_name: it.txt_area_name ?? it.area_name ?? '',
        dc_lat_num: it.dc_lat_num ?? it.area_lat ?? null,
        dc_lng_num: it.dc_lng_num ?? it.area_lng ?? null,
        _sum: 0
      };
    }

    groups[key]._sum += addVal;

    if ((groups[key].dc_lat_num == null || groups[key].dc_lng_num == null) && (it.dc_lat_num != null && it.dc_lng_num != null)) {
      groups[key].dc_lat_num = it.dc_lat_num;
      groups[key].dc_lng_num = it.dc_lng_num;
    }
    if (!groups[key].city_code && (it.city_code || it.cityCode)) {
      groups[key].city_code = it.city_code ?? it.cityCode;
    }
    if (!groups[key].txt_city_name && it.txt_city_name) {
      groups[key].txt_city_name = it.txt_city_name;
    }
    if (!groups[key].txt_area_name && it.txt_area_name) {
      groups[key].txt_area_name = it.txt_area_name;
    }
  }

  const ary = Object.values(groups)
    .map(g => ({
      id: g.id,
      code: g.code,
      city_code: g.city_code,
      txt_city_name: g.txt_city_name,
      txt_area_name: g.txt_area_name,
      dc_lat_num: g.dc_lat_num,
      dc_lng_num: g.dc_lng_num,
      [rankKey]: Number(g._sum) || 0
    }))
    .sort((a, b) => {
      if (b[rankKey] !== a[rankKey]) return b[rankKey] - a[rankKey];
      return String(a.city_code ?? '').localeCompare(String(b.city_code ?? ''));
    });

  return ary.slice(0, limit);
};

// 避難所分析の日時を全て取得したデータを返す
export const getShelterDateTime = (data) => {
  if (!Array.isArray(data)) return [];
  const set = new Set();
  data.forEach(item => {
    if (!item) return;
    const t = item.tsm_report_time;
    if (t !== undefined && t !== null && String(t).trim() !== '') {
      set.add(String(t).trim());
    }
  });

  const ary = Array.from(set);

  ary.sort((a, b) => {
    const ta = Date.parse(a);
    const tb = Date.parse(b);
    if (isNaN(ta) || isNaN(tb)) {
      return a.localeCompare(b);
    }
    return ta - tb; // 昇順（古い日付 → 新しい日付）
  });

  return ary;
};


// 避難所分析の日時の避難者数のトータル件数を返す
export const getEvacDateData = (data, datetime) => {
  if (!Array.isArray(data) || !Array.isArray(datetime)) return [];
  const keys = datetime.map(d => String(d ?? '').trim());
  const targetSet = new Set(keys);
  const sums = {};
  for (const k of keys) sums[k] = 0;

  const getNum = (item, key) => {
    if (!item) return 0;
    const tryKeys = [key, key.toUpperCase(), key.toLowerCase()];
    for (const k of tryKeys) {
      const v = item[k];
      if (v !== undefined && v !== null && v !== '') return Number(v) || 0;
    }
    return 0;
  };

  data.forEach(item => {
    if (!item) return;
    const t = item.tsm_report_time;
    if (t === undefined || t === null) return;
    const ts = String(t).trim();
    if (!targetSet.has(ts)) return;
    const val = getNum(item, 'int_hdcnt_num');
    sums[ts] = (sums[ts] || 0) + val;
  });
  const categories = [];
  const dataEvac = [];
  Object.entries(sums).forEach(([key, value]) => {
    if (value > 0) {
      categories.push(key);
      dataEvac.push(value);
    }
  });

  return { categories, data: dataEvac };
};

// 避難所分析の日時の避難所を全て取得したデータを返す
export const getDateData = (data, datetime) => {
  if (!Array.isArray(data) || !Array.isArray(datetime)) return [];

  const targetSet = new Set(datetime.map(d => String(d ?? '').trim()));
  const counts = {};
  for (const d of targetSet) counts[d] = 0;

  data.forEach(item => {
    if (!item) return;
    const t = item.tsm_report_time;
    if (t === undefined || t === null) return;
    const ts = String(t).trim();
    if (targetSet.has(ts)) counts[ts] = (counts[ts] || 0) + 1;
  });

  return datetime.map(d => counts[String(d ?? '').trim()] || 0);
};// 避難所分析のshelter_codeを基にcity_code全て取得した配列で返す


export const getShelterAnalysisRankData = (data, limit) => {
  if (!Array.isArray(data)) return [];

  const rateKeys = {
    rate_covid: 'rate_covid',
    rate_flu: 'rate_flu',
    rate_myco: 'rate_myco',
    rate_myco_child: 'rate_myco_child',
    rate_rs: 'rate_rs',
    rate_chlamydia: 'rate_chlamydia',
    rate_herpangina: 'rate_herpangina',
    rate_mumps: 'rate_mumps',
    rate_rota: 'rate_rota',
    rate_pharyngoconjunctival: 'rate_pharyngoconjunctival',
    rate_apple: 'rate_apple',
    rate_acute_hemorrhagic_conjunctivitis: 'rate_acute_hemorrhagic_conjunctivitis',
    rate_hand_foot_mouth: 'rate_hand_foot_mouth',
    rate_acute_infectious_gastroenteritis: 'rate_acute_infectious_gastroenteritis',
    rate_chicken_pox: 'rate_chicken_pox',
    rate_epidemic_conjunctivitis: 'rate_epidemic_conjunctivitis',
    rate_aseptic_spinal_cord_meningitis: 'rate_aseptic_spinal_cord_meningitis',
    rate_exanthem_subitum: 'rate_exanthem_subitum',
    rate_bacterial_meningitis: 'rate_bacterial_meningitis',
    rate_group_a_hemolytic: 'rate_group_a_hemolytic'
  };

  const map = {}; // code -> aggregation

  data.forEach(item => {
    const areaKey = item.code || item.area || '__unknown__';

    if (!map[areaKey]) {
      map[areaKey] = {
        code: item.code || null,
        area: item.area || '不明',
        total: 0
      };

      // init rate counters
      Object.keys(rateKeys).forEach(k => {
        map[areaKey][k] = 0;
      });
    }

    // 各感染症のrateを加算
    Object.entries(rateKeys).forEach(([outKey, rawKey]) => {
      const value = Number(item[rawKey]) || 0;
      map[areaKey][outKey] += value;
      map[areaKey].total += value;
    });
  });

  const result = Object.values(map)
    .sort((a, b) => b.total - a.total)
    .slice(0, limit);

  return result;
};

export const getAllByMshCode = (code_ary, apiData, isH6) => {
  let all_data = apiData
  // 6時間モードの場合０番目から12番目までの値
  if (isH6) {
      all_data = apiData.map(item => {
          const newItem = { code: item.msh_code };

          for (const [key, value] of Object.entries(item)) {
              if (Array.isArray(value)) {
                  newItem[key] = value.slice(0, -9); // 配列なら末尾9つカット
              }
          }
          return newItem;
      });
  }
  // 必要なコードのもののみ抽出
  const result = all_data.filter(item =>
      code_ary.includes(item.msh_code)
  );
  return result
};

export const getAllByMshCodeNotNull = (data, isH6) => {
    if (!Array.isArray(data)) return [];
    return data.filter(item => item && item.msh_code !== null && item.msh_code !== undefined);
};

export const convertRoadDataFromMshData = (features, data) => {
  const maxArray = (arr) => Math.max(...arr);
  const map = {};
  data.forEach(item => {
    const msh_code = item.code;
    const filteredFeatures = features.find(f => f.properties.id === msh_code);
    if (!filteredFeatures) return;
    
    const city_code = filteredFeatures.properties.city_code;
    const city_name = item.city_name;
    const txt_road_name = item.txt_road_name;
    const lat_lng = getPolygonOrMultiPolygonCenter(filteredFeatures.geometry.coordinates);
    const area_lng = lat_lng[0];
    const area_lat = lat_lng[1];
    const risk_val = item.rsk_dc_value_num;

    const key = `${city_name}_${txt_road_name}`;
    const currentMax = maxArray(risk_val);
    if (!map[key]) {
        map[key] = { msh_code, city_code, city_name, txt_road_name, area_lat, area_lng, risk_val, max: currentMax };
    } else {
      const existMax = maxArray(map[key].risk_val);
      if (currentMax > existMax) {
        map[key] = { msh_code, city_code, city_name, txt_road_name, area_lat, area_lng, risk_val, max: currentMax };
      }
    }
  });
  return Object.values(map);
};

/**
 * 全日時断面のリスクに地域情報を付与する
 * @param {Object} features - 地域情報取得用のデータ
 * @param {Object} data - 全日時断面のリスクデータ
 * @returns {Array} 全日時断面のリスクと地域情報
 */
export const getAllByDateTimeCityInfo = (features, data) => {
  const result = data.map(item => {
    const city_code = item.code
    // 対象字コードの feature を抽出
    const filteredFeatures = features.find(f =>
      f.properties.city_code === city_code
    );
    // featureから字名を取得
    const city_name = filteredFeatures.properties.city_name

    // featureから緯度経度を取得
    const lat_lng = getPolygonOrMultiPolygonCenter(filteredFeatures?.geometry?.coordinates)
    const area_lng = lat_lng[0]
    const area_lat = lat_lng[1]
    const risk_val = item.soil_index_level
    return { city_code, city_name, area_lat, area_lng, risk_val };
  });
  return result
};

// Start chronology
export const getAllByMshCodeChronology = (code_ary, apiData, isH6) => {
  if (!Array.isArray(apiData)) return [];

  const result = [];
  for (const item of apiData) {
    if (!item || item.msh_code == null) continue;
    if (!code_ary.includes(item.msh_code)) continue;

    if (isH6) {
      const newItem = { msh_code: item.msh_code };

      for (const [key, value] of Object.entries(item)) {
        if (Array.isArray(value)) {
          newItem[key] = value.slice(0, -9);
        }
      }
      result.push(newItem);
    } else {
        result.push(item);
    }
  }

  return result;
};

/**
 * Converts mesh risk data into scatter-ready city risk points
 * - Calculates max risk values
 * - Extracts centroid coordinates
 *
 * @param {Array} mshMasterFeatures
 * @param {Array} data
 * @returns {Array} scatter plot city data
 */
export const convertCityDataRiskFromMshData = (mshMasterFeatures, data) => {
  const idToFeatureMap = {};
  for (const feature of mshMasterFeatures) {
    let id = feature.properties.id;
    idToFeatureMap[id] = feature;
  }

  // 一時格納用：city_code をキーにして統合
  const cityDataMap = {};

  for (const d of data) {
    let matchedFeature = idToFeatureMap[d.code];
    if (!matchedFeature) continue;

    let { city_code, city_name } = matchedFeature.properties;
    if (!city_code) continue;

    let lat_lng = getPolygonOrMultiPolygonCenter(matchedFeature.geometry.coordinates);
    let max_risk = Array.isArray(d.rsk_dc_value_num) ? Math.max(...d.rsk_dc_value_num) : null;
    let max_dc_tank_of = Array.isArray(d.dc_tank_of_num) ? Math.max(...d.dc_tank_of_num) : null;
    let max_h1 = Array.isArray(d.h1_dc_value_num) ? Math.max(...d.h1_dc_value_num) : null;
    let max_h24 = Array.isArray(d.h24_dc_value_num) ? Math.max(...d.h24_dc_value_num) : null;
    let max_h48 = Array.isArray(d.h48_dc_value_num) ? Math.max(...d.h48_dc_value_num) : null;
    let max_soil = Array.isArray(d.soil_index_level) ? Math.max(...d.soil_index_level) : null;

    if (!cityDataMap[city_code]) {
      cityDataMap[city_code] = {
        msh_code: d.code, // 最初の msh_code を使う（代表）
        city_code,
        name: city_name || '',
        risk_val: max_risk,
        h1_val: max_h1,
        h24_val: max_h24,
        h48_val: max_h48,
        dc_tank_of_val: max_dc_tank_of,
        h1_dc_tank_of_val: [max_h1, max_dc_tank_of],
        h1_h24_val: [max_h1, max_h24],
        area_lng: lat_lng[0],
        area_lat: lat_lng[1],
        soil_index_level: max_soil
      };
    } else {
      // 既存の最大値と比較して更新
      const existing = cityDataMap[city_code];
      existing.risk_val = Math.max(existing.risk_val ?? -Infinity, max_risk ?? -Infinity);
      existing.h1_val = Math.max(existing.h1_val ?? -Infinity, max_h1 ?? -Infinity);
      existing.h24_val = Math.max(existing.h24_val ?? -Infinity, max_h24 ?? -Infinity);
      existing.h48_val = Math.max(existing.h48_val ?? -Infinity, max_h48 ?? -Infinity);
      existing.dc_tank_of_val = Math.max(existing.dc_tank_of_val ?? -Infinity, max_dc_tank_of ?? -Infinity);
      existing.h1_dc_tank_of_val = [existing.h1_val, existing.dc_tank_of_val];
      existing.h1_h24_val = [existing.h1_val, existing.h24_val];
      existing.soil_index_level = Math.max(existing.soil_index_level ?? -Infinity, max_soil ?? -Infinity);
    }
  }
  return Object.values(cityDataMap);
};

  /**
  * 全日時断面のリスクに地域情報を付与する
  * @param {Object} features - 地域情報取得用のデータ
  * @param {Object} data - 全日時断面のリスクデータ
  * @returns {Array} 全日時断面のリスクと地域情報
  */
export const getAllByDateTimeWithAreaRisk = (features, data) => {
  const result = data.map(item => {
    const area_code = item.code
    // 対象字コードの feature を抽出
    const filteredFeatures = features.find(f =>
      f.properties.area_code === area_code
    );
    // featureから字名を取得
    const city_name = filteredFeatures.properties?.city_name;
    const area_name = filteredFeatures.properties?.area_name;
    const name = filteredFeatures.properties?.name;

    // featureから緯度経度を取得
    let max_risk = Array.isArray(item.rsk_dc_value_num) ? Math.max(...item.rsk_dc_value_num) : null;
    let max_dc_tank_of = Array.isArray(item.dc_tank_of_num) ? Math.max(...item.dc_tank_of_num) : null;
    let max_h1 = Array.isArray(item.h1_dc_value_num) ? Math.max(...item.h1_dc_value_num) : null;
    let max_h24 = Array.isArray(item.h24_dc_value_num) ? Math.max(...item.h24_dc_value_num) : null;
    let max_soil = Array.isArray(item.soil_index_level) ? Math.max(...item.soil_index_level) : null;
    const lat_lng = getPolygonOrMultiPolygonCenter(filteredFeatures?.geometry?.coordinates)
    const area_lng = lat_lng[0]
    const area_lat = lat_lng[1]
    return {
      area_code,
      city_name,
      area_name,
      name,
      area_lat,
      area_lng,
      risk_val: max_risk,
      soil_index_level: max_soil,
      h1_dc_tank_of_val: [max_h1, max_dc_tank_of],
      h1_h24_val: [max_h1, max_h24]
    };
  });
  return result
};

/**
 * Calculates maximum H1 risk per code group
 * - Supports grouping by substring (city, area, mesh)
 *
 * @param {Array} data
 * @param {number} substringLength
 * @returns {Array}
 */
export const getRiskH1MaxByCode = (data, substringLength = 0) => {
  const resultMap = {};
  data.forEach(({ code, rsk_dc_value_num, h1_dc_value_num, soil_index_level }) => {
    let groupCode = code
    if (substringLength > 0)
      groupCode = String(code).slice(0, substringLength); // 先頭5桁（例：11111）

    // const maxRisk = Math.max(...rsk_dc_value_num.slice(6));
    const maxH1 = Math.max(...h1_dc_value_num.slice(6));
    const maxSoil = Math.max(...soil_index_level.slice(6));

    if (!resultMap[groupCode]) {
      resultMap[groupCode] = { code: Number(groupCode), risk_val: maxSoil, h1_val: maxH1 };
    } else {
      resultMap[groupCode].risk_val = Math.max(resultMap[groupCode].risk_val, maxSoil);
      resultMap[groupCode].h1_val = Math.max(resultMap[groupCode].h1_val, maxH1);
    }
  });

  // 最後に配列にして返す
  const result = Object.values(resultMap);
  return result;
};